import { jsx } from 'react/jsx-runtime';
import { CarouselPlaybackButton } from '../CarouselPlaybackButton/CarouselPlaybackButton.esm.js';
import carouselAutoplayToggleStyles from './CarouselAutoplayToggle.styles.esm.js';

function CarouselAutoplayToggle({ autoAdvance, isPlaying, onToggle, inverse, itemsInView, }) {
    if (!autoAdvance)
        return null;
    const styles = carouselAutoplayToggleStyles();
    return (jsx(CarouselPlaybackButton, { inverse: inverse, onClick: onToggle, className: styles, type: isPlaying ? "pause" : "play", "aria-pressed": !isPlaying, "aria-label": isPlaying ? "Pause carousel" : "Play carousel", variant: itemsInView === 1 ? "floating-over-image" : "floating" }));
}

export { CarouselAutoplayToggle };
